// @flow

import * as React from 'react';
import BuildDuration from 'app/components/build/Duration';
import BuildMessage from 'app/components/build/Message';
import FriendlyTime from 'app/components/shared/FriendlyTime';
import BuildState, { type BuildStates } from 'app/components/icons/BuildState';
import { shortCommit } from 'app/lib/commits';

type Props = {
  number: number,
  message: string,
  state: BuildStates,
  blockedState?: string,
  path: string,
  commitId: string,
  commitShortLength: number,
  authorName: string,
  createdAt: string,
  scheduledAt?: string,
  startedAt?: string,
  canceledAt?: string,
  finishedAt?: string
};

export default class BuildRow extends React.PureComponent<Props> {
  buildStateForNewFrontend() {
    // TODO: The new frontend gear expects "running" (as per the GraphQL API) but the
    // React presenters and JSON endpoints still return "started"
    //
    // This can be `rm -rf`'d when it's moved across to GraphQL
    if (this.props.state === "started") {
      return "RUNNING";
    }

    return this.props.state.toUpperCase();
  }

  blockedState() {
    if (this.props.blockedState === null || this.props.blockedState === undefined) {
      return this.props.blockedState;
    }

    return this.props.blockedState.toUpperCase();
  }

  render() {
    return (
      <div className="build-row">
        <a
          href={this.props.path}
          className="text-decoration-none black hover-black flex py2 items-center"
        >
          <span className="center pl3 flex-none">
            <BuildState.Small
              className="block"
              state={this.buildStateForNewFrontend()}
              blockedState={this.blockedState()}
            />
          </span>
          <span className="flex-1 px2">
            <span className="block semi-bold" style={{ marginBottom: '0.1em' }}>
              <BuildMessage message={this.props.message} />
            </span>
            <span className="block dark-gray h6 m0 regular">
              {this.props.authorName}
              {' — Build #'}
              {this.props.number}
              {" ("}
              <span className="monospace">
                {shortCommit(this.props.commitId, this.props.commitShortLength)}
              </span>
              {') — '}
              <FriendlyTime
                value={this.props.createdAt}
                capitalized={true}
                clickable={false}
              />
            </span>
          </span>
          <span className="flex-none right-align dark-gray ml-auto pl2 pr3">
            <BuildDuration
              build={{
                state: this.props.state,
                scheduledAt: this.props.scheduledAt,
                startedAt: this.props.startedAt,
                canceledAt: this.props.canceledAt,
                finishedAt: this.props.finishedAt
              }}
              durationFormat="Micro"
            />
          </span>
        </a>
      </div>
    );
  }
}
